import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const CompletionCelebration = ({ isVisible, onClose, challengeTitle, totalStars }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [isVisible]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-dialog bg-background/95 flex items-center justify-center p-4"
    >
      <div
        className="relative bg-card rounded-lg shadow-gaming-lg p-8 md:p-12 max-w-md w-full text-center"
      >
        <button
          type="button"
          onClick={() => {
            setShow(false);
            onClose?.();
          }}
          className="absolute top-3 right-3 p-2 rounded-md text-muted-foreground hover:bg-muted transition-gaming"
          aria-label="닫기"
        >
          <Icon name="X" size={20} />
        </button>

        <div
          className="w-24 h-24 md:w-32 md:h-32 bg-primary rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <Icon name="Trophy" size={48} color="var(--color-primary-foreground)" />
        </div>

        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-3">
          축하합니다! 🎉
        </h2>

        <p className="text-base md:text-lg text-muted-foreground mb-6">
          <span className="font-semibold text-foreground">{challengeTitle}</span>
          <br />
          챌린지를 완료했습니다!
        </p>

        <div className="flex items-center justify-center space-x-2 mb-8">
          <Icon name="Star" size={24} color="var(--color-accent)" className="fill-current" />
          <span className="text-3xl md:text-4xl font-heading font-bold text-accent data-text">
            {totalStars}
          </span>
          <span className="text-lg text-muted-foreground">별 획득</span>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => {
              setShow(false);
              onClose?.();
            }}
            className="w-full px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium transition-gaming hover:bg-primary/95 active:bg-primary/90 active:translate-y-px"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletionCelebration;